/**
 * apiError — extract a user-facing message from an Axios error response.
 *
 * NestJS validation errors return `message` as either a string or string[].
 * Falls back to `fallback` when the response doesn't carry a message.
 */
export function extractApiError(err: unknown, fallback: string): string {
  const msg = (err as { response?: { data?: { message?: unknown } } } | null)
    ?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (Array.isArray(msg)) return (msg as string[]).join('; ');
  return fallback;
}
